module.exports = __webpack_public_path__ + "static/media/product expensive.a6e81d97.webp";